import { ProposalDecision, } from '@debbie/common/dist/agents/index.js';
import { proposalTitle } from '@debbie/cortex/dist/agents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypes } from '@debbie/cortex/dist/update-types/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { prefetchCaseOnHover } from '../../utils/prefetch-case.js';
import Badge from '../Badge.js';
import { CaseHistoryFocusKind, caseHistoryLink } from '../Hist/focus.js';
import ChevronRight from '../Icons/ChevronRight.js';
import { ReportRow, ReportRowAside, ReportRowBody, ReportRowLink, ReportRowMeta, ReportRowSecondaryLink, ReportRowText, ReportRowTitle, } from '../Insights/ReportList.js';
import UpdateTypeLabel from '../UpdateTypeLabel.js';
import { Description } from './shared.js';
const DECISION_COLOR = {
    [ProposalDecision.Pending]: THEME.COLOR_ACCENT,
    [ProposalDecision.ApprovedAsIs]: THEME.SUCCESS,
    [ProposalDecision.Edited]: THEME.SUCCESS,
    [ProposalDecision.Rejected]: THEME.DANGEROUS,
    [ProposalDecision.Failed]: THEME.DANGEROUS,
    [ProposalDecision.Closed]: THEME.COLOR_GREY,
};
const ProposalList = ({ proposals }) => {
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable = useUpdateTypes();
    const updateTypeLabels = new Map((h.hasData(updateTypesLoadable) ? updateTypesLoadable.data : []).map((updateType) => [updateType.updateTypeId, updateType.label]));
    if (proposals.length === 0) {
        return React.createElement(Description, null, lang.agentPerformance.noProposals);
    }
    return (React.createElement("div", null, proposals.map((proposal) => (React.createElement(ReportRow, { key: proposal.id, ...prefetchCaseOnHover(proposal.caseId) },
        React.createElement(ReportRowBody, null,
            React.createElement(ReportRowTitle, null,
                React.createElement(ReportRowLink, { to: caseHistoryLink(proposal.caseId, CaseHistoryFocusKind.Proposal, proposal.id) }, proposalTitle(proposal.toolName, proposal.input, lang))),
            proposal.reasoning != null && (React.createElement(ReportRowText, null, proposal.reasoning)),
            React.createElement(ReportRowMeta, null,
                React.createElement("span", { title: moment(proposal.proposedAt).format('LLL') }, moment(proposal.proposedAt).fromNow()),
                proposal.updateTypeId != null && (React.createElement(React.Fragment, null,
                    ' · ',
                    React.createElement(ReportRowSecondaryLink, { to: `/settings/workflows/tasks/${proposal.updateTypeId}` },
                        lang.agentPerformance.task,
                        ":",
                        ' ',
                        React.createElement(UpdateTypeLabel, { updateTypeId: proposal.updateTypeId, label: updateTypeLabels.get(proposal.updateTypeId) ?? '' })))))),
        React.createElement(ReportRowAside, null,
            React.createElement(Badge, { theme: DECISION_COLOR[proposal.decision], style: { marginBottom: 0 } }, lang.agentPerformance.decisions[proposal.decision]),
            React.createElement(ChevronRight, { color: THEME.COLOR_GREY })))))));
};
export default ProposalList;
//# sourceMappingURL=ProposalList.js.map